'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { DialogPanel } from '@headlessui/react';
import classNames from '@/utils/classNames';
import { modalVariants } from './Modal.variants';
import type { ModalPanelProps } from './Modal.types';
export const MODAL_VARIANT_QS = 'mv' as const;
const Panel = t0 => {
  const $ = _c(34);
  let children;
  let className;
  let props;
  let ref;
  let shadow;
  let t1;
  let t2;
  let wrapperClassName;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      shadow,
      children,
      wrapperClassName,
      useQueryVariant: t2,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = ref;
    $[5] = shadow;
    $[6] = t1;
    $[7] = t2;
    $[8] = wrapperClassName;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    ref = $[4];
    shadow = $[5];
    t1 = $[6];
    t2 = $[7];
    wrapperClassName = $[8];
  }
  const defaultVariant = t1 === undefined ? "default" : t1;
  const useQueryVariant = t2 === undefined ? true : t2;
  const t3 = useSearchParams();
  let T0;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[9] !== className || $[10] !== defaultVariant || $[11] !== props.as || $[12] !== ref || $[13] !== shadow || $[14] !== t3 || $[15] !== useQueryVariant || $[16] !== wrapperClassName) {
    const queryVariant = t3.get(MODAL_VARIANT_QS);
    const variant = (useQueryVariant === false ? defaultVariant : queryVariant ?? defaultVariant) as ModalPanelProps['variant'];
    if ($[22] !== wrapperClassName) {
      t7 = classNames("pointer-events-none fixed inset-0 isolate z-50 flex w-screen items-center justify-center", wrapperClassName);
      $[22] = wrapperClassName;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    T0 = DialogPanel;
    t4 = ref;
    t5 = props.as;
    t6 = classNames(modalVariants({
      variant,
      shadow
    }), className);
    $[9] = className;
    $[10] = defaultVariant;
    $[11] = props.as;
    $[12] = ref;
    $[13] = shadow;
    $[14] = t3;
    $[15] = useQueryVariant;
    $[16] = wrapperClassName;
    $[17] = T0;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    T0 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
  }
  let t8;
  if ($[24] !== T0 || $[25] !== children || $[26] !== props || $[27] !== t4 || $[28] !== t5 || $[29] !== t6) {
    t8 = <T0 ref={t4} as={t5} className={t6} {...props}>{children}</T0>;
    $[24] = T0;
    $[25] = children;
    $[26] = props;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t7 || $[32] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
};
export default Panel;